module.exports = __webpack_public_path__ + "static/media/age.2a6dbbff.svg";